import * as React from 'react';
import { makeShadowConfig } from '@fluentui/merge-styles';
/**
 * Get a shadow config.
 * @param stylesheetKey - Globally unique key
 * @param win - Reference to the `window` global.
 * @returns ShadowConfig
 */
export var useShadowConfig = function (stylesheetKey, inShadow, win) {
    if (inShadow === void 0) { inShadow = false; }
    return React.useMemo(function () {
        return makeShadowConfig(stylesheetKey, inShadow, win);
    }, [stylesheetKey, inShadow, win]);
};
//# sourceMappingURL=useShadowConfig.js.map